import React from 'react'
import { Col, Row } from 'reactstrap'

const PathogenRequired = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5 py-4'>
            <Row className=''>
                <Col sm='12' md='7' className=''>
                    <div className=''>
                        <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                            WHY DO I REQUIRE A PANEL OF RESPIRATORY PATHOGENS?
                        <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>
                    </div>

                    <div className='pt-2'>
                        <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        You need RPP lab test in Chicago to check the Infections with viruses like: Influenza, Common cold, Respiratory syncytial virus.
                        </div>
                    </div>

                    <div className='pt-2'>
                        <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        Typically, these are mild respiratory infections that are common. However, any of them can be harmful to infants and the elderly.
                        </div>
                    </div>
                </Col>

                <Col sm='12' md='5' className='pt-md-5 pt-lg-0 pt-4'>
                <Row  className='flex-center'>
                    <Col xs='6' sm='6' md='6'  className='flex-center'>
                        <div className=''>
                        <div className='flex-center'>
                            <img src='pathogen-testing/RPP-Testing-icon1.png' alt='' height='auto' width='80px'  />
                            </div>
                            <div className='flex-center fw-600 text-montserrat text-ss-black fs-ss-18'>Influenza</div>
                        </div>
                        </Col>
                        <Col xs='6' sm='6' md='6' className='flex-center'>
                        <div className=''>
                        <div className='flex-center'>
                            <img src='pathogen-testing/RPP-Testing-icon2.png' alt='' height='auto' width='80px'  />
                            </div>
                            <div className='flex-center fw-600 text-montserrat text-ss-black fs-ss-18'>Common Cold</div>
                        </div>
                    </Col>
                    </Row>

                    {/* <Row className='mt-4 flex-center'> */}
                    <Col xs='12' md='12'  className='flex-center mt-4'>
                        <div className=''>
                        <div className='flex-center'>
                            <img src='pathogen-testing/RPP-Testing-icon3.png' alt='' height='auto' width='80px'  />
                            </div>
                            <div className='flex-center fw-600 text-montserrat text-ss-black lh-1-2 fs-ss-18'><center>Respiratory<br/>Syncytial Virus</center></div>
                        </div>
                        </Col>

                        
                {/* </Row> */}
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default PathogenRequired